// EUDAMED XML exports for the selected products, used by the Products and UDIs tables
export const productsEudamedXmlServices = [
    {
        value: "UDI_DI_UPDATE",
        label: "Update (Master) UDI-DIs",
        url: "/umbraco/api/RIMSProducts/GenerateEUUDIUpdateXml/?productIds=",
        filename: "UDIDIUpdate.xml",
    },
    {
        value: "MARKET_INFO_UPDATE",
        label: "Update Market Information (countries)",
        url: "/umbraco/api/RIMSProducts/GenerateMarketInfoUpdateXml/?productIds=",
        filename: "MarketInfoUpdate.xml",
    },
    {
        value: "PACKAGE_UDI_UPDATE",
        label: "Update Container Packages",
        url: "/umbraco/api/RIMSProducts/GeneratePackageUdiUpdateXml/?productIds=",
        filename: "PackageUDIUpdate.xml",
    },
    {
        value: "PRODUCT_DESIGNER_UPDATE",
        label: "Update Product Designer / original manufacturer",
        url: "/umbraco/api/RIMSProducts/GenerateProductDesignerUpdateXml/?productIds=",
        filename: "ProductDesignerUpdate.xml",
    },
    {
        value: "UDI_DI_REGISTER",
        label: "Register new (Master) UDI-DIs under existing Basic UDI-DI (zip)",
        url: "/umbraco/api/RIMSProducts/GenerateAdditionalEUUDIsZip/?productIds=",
        filename: "AdditionalUDIDIs.zip",
    },
];

// Same exports keyed by EU UDI version id, used by the EU UDIs table (rows are versions)
export const euUdiVersionsEudamedXmlServices = productsEudamedXmlServices.map(service => ({
    ...service,
    url: service.url.replace("?productIds=", "?euUdiIds="),
}));
